import React from 'react';
import { CTABand } from '../../components/CTABand';
export function FamilyFinalCTA() {
  return <CTABand headline="Ready to Train Together as a Family?" copy="Schedule a family trial class — beginners welcome at every age. Storm will help you choose a class time that fits everyone's schedule. Call 517-220-0621 or fill out the form on this page." data-id="element-1079" />;
}